import { NavigationScrollEffectEnum } from "@/scripts/common/enums.js";

export default {
    computed: {
        isStickyEffect() {
            return this.section?.scrollEffect === NavigationScrollEffectEnum.STAY_ON_TOP;
        },
        isAutoHideEffect() {
            return this.section?.scrollEffect === NavigationScrollEffectEnum.ANIMATE_OUT_AND_BACK;
        },
        isPinnedEffect() {
            return this.isStickyEffect || this.isAutoHideEffect;
        },
    },
};
